<template>
  <button type="button" class="btn btn-success flex-item" @click="download">
    <em class="fa fa-cloud-download-alt"/>
    Download
  </button>
</template>

<script>
import FileHelper from "@/helpers/FileHelper";

export default {
  name: "DesignDownloadButton",
  props: {
    value: {
      type: Object,
      default: Object
    }
  },
  methods: {
    download() {
      const url = FileHelper.createLinkEmb(this.value)
      const link = document.createElement('a');
      link.href = url;
      link.download = url;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }
}
</script>